import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {Requests, RequestsCancelRequest} from 'src/app/_model/Requests';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {LookupService} from '../../_services/lookup.service';
import {RequestService} from "../../_services/request.service";
@Component({
    selector: 'app-requestsCancel',
    templateUrl: './requestsCancel.component.html',
    styleUrls: ['./requestsCancel.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule
    ]
})
export class RequestsCancelComponent implements OnInit {

    request: RequestsCancelRequest = new RequestsCancelRequest();
    currentUser: User;
    description: any = {};
    rejectReasons: any[];
    rejectDescription = '';

    constructor(public dialogRef: MatDialogRef<RequestsCancelComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests,
                private authService: AuthenticationService,
                private requestService: RequestService,
                private toastr: ToastrService,
                private lookupService: LookupService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
        this.rejectReasons = this.lookupService.localRejectReasonLookupList();
    }

    rejectAbsence(requests: Requests) {
        this.request.id = requests.id;
        this.request.description = requests.description;

        this.requestService.cancelRequest(this.request).subscribe(result => {
            this.toastr.success('iptal işlemi başarılı', '');
            this.dialogRef.close(true);
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close(false);
        });
    }
}
